import { render, staticRenderFns } from "./goldData.vue?vue&type=template&id=65bc93a4&scoped=true&"
import script from "./goldData.vue?vue&type=script&lang=js&"
export * from "./goldData.vue?vue&type=script&lang=js&"
import style0 from "./goldData.vue?vue&type=style&index=0&id=65bc93a4&scoped=true&lang=scss&"
import style1 from "./goldData.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65bc93a4",
  null
  
)

export default component.exports